import { handleErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { TransparentBox } from '@juvare/common-web-ui/TransparentBox';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import { Button, Grid, Typography } from '@mui/material';
import React from 'react';
import { useDocumentLibraryStorage, useDocumentLibraryTranslations, useHighestPermissionText, useUpdatePermissions, } from '../../../../../hooks';
import { DocumentLibraryContext } from '../../../../../providers';
export const FolderAccessPlaceholder = ({ permissions, sharedData, onManagePermissions, currentFolder, }) => {
    const { t } = useDocumentLibraryTranslations();
    const { reloadParents } = React.useContext(DocumentLibraryContext);
    const highestPermission = useHighestPermissionText(permissions);
    const { updatePermissions } = useUpdatePermissions();
    const storage = useDocumentLibraryStorage();
    const canModify = currentFolder === null || currentFolder === void 0 ? void 0 : currentFolder.permissions.includes('modify');
    const getSharedText = () => {
        const textArray = [];
        if (sharedData.accounts === 0 && sharedData.organizations === 0 && sharedData.systemRoles === 0 && !sharedData.isPublic) {
            textArray.push(t('folderAccessPlaceholder.notShared'));
        }
        if (sharedData.accounts > 0) {
            textArray.push(t('folderAccessPlaceholder.accountsShared', { number: sharedData.accounts }));
        }
        if (sharedData.organizations > 0) {
            textArray.push(t('folderAccessPlaceholder.organizationsShared', { number: sharedData.organizations }));
        }
        if (sharedData.systemRoles > 0) {
            textArray.push(t('folderAccessPlaceholder.systemRolesShared', { number: sharedData.systemRoles }));
        }
        if (sharedData.isPublic) {
            textArray.push(t('folderAccessPlaceholder.publicShared'));
        }
        return textArray.join(', ');
    };
    return (React.createElement(TransparentBox, { "data-test": 'folder-access-placeholder' },
        React.createElement(Grid, { container: true, sx: { alignContent: 'center', justifyContent: 'space-between', pb: 2 } },
            React.createElement(Typography, { variant: 'subtitle2', sx: {
                    alignItems: 'center',
                    color: themeColors.text.inverse,
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1,
                    wordWrap: 'break-word',
                } },
                React.createElement(ShareOutlinedIcon, null),
                t('folderAccessPlaceholder.access')),
            canModify && (React.createElement(Button, { variant: 'text', size: 'small', sx: { color: themeColors.accent.blue.subtle }, onClick: () => {
                    if (currentFolder === null || currentFolder === void 0 ? void 0 : currentFolder.id) {
                        storage.fileStorageClient
                            .get(currentFolder === null || currentFolder === void 0 ? void 0 : currentFolder.id)
                            .then((entityData) => {
                            if (onManagePermissions && entityData) {
                                onManagePermissions(entityData, (permissions) => updatePermissions({ permissions, id: entityData.id, onSuccess: () => reloadParents() }));
                            }
                        })
                            .catch(handleErrorDialog);
                    }
                }, "data-test": 'manage-button' }, t('folderAccessPlaceholder.manage')))),
        React.createElement(Grid, { container: true, gap: 1, flexWrap: 'nowrap' },
            React.createElement(Grid, { item: true, xs: 6, sm: 4 },
                React.createElement(Typography, { variant: 'body2', sx: { color: themeColors.text.inverse, wordWrap: 'break-word' } }, t('folderAccessPlaceholder.myAccess'))),
            React.createElement(Grid, { item: true, xs: 6, sm: 8 },
                React.createElement(Typography, { variant: 'subtitle2', sx: { color: themeColors.text.inverse, wordWrap: 'break-word' }, "data-test": 'my-access' }, highestPermission))),
        React.createElement(Grid, { container: true, gap: 1, flexWrap: 'nowrap' },
            React.createElement(Grid, { item: true, xs: 6, sm: 4 },
                React.createElement(Typography, { variant: 'body2', sx: { color: themeColors.text.inverse, wordWrap: 'break-word' } }, t('folderAccessPlaceholder.sharedAccess'))),
            React.createElement(Grid, { item: true, xs: 6, sm: 8 },
                React.createElement(Typography, { variant: 'subtitle2', sx: { color: themeColors.text.inverse, wordWrap: 'break-word' }, "data-test": 'shared-access' }, getSharedText())))));
};
